import { mapGetters, mapActions } from 'vuex';
import { EventBus, GAME_ACCOUNT_CONNECTION_TOGGLE_MODAL, SHOW_MODAL_BOOM_MESSAGE, SHOW_MODAL_ONBOARDING_INITIAL } from '../event-bus';
import { RouteHub } from './route-hub';
import { ModalMixin } from './modal';
import { HubMemberMixin } from './hub_member';
import { helper } from './helper';
import { gaEvent } from './ga-event';

export const HubMixin = {
  mixins: [RouteHub, ModalMixin, HubMemberMixin, helper, gaEvent],
  data() {
    return {
      // hub brand
      HUB_BRAND_NORMAL: 0,
      HUB_BRAND_INTEL_INSPIRES: 1,
      HUB_BRAND_OPEN_WEEKLY: 2,
      HUB_BRAND_TEXSEF_HIGH_SCHOOL: 4,
      // hub role management
      ROLE_MANAGER: 'manager',
      ROLE_SUBSTITUTE: 'substitute',
      ROLE_MAIN_ROSTER: 'main_roster',
      TEAM_ROLE_MANAGER: 0,
      TEAM_ROLE_CAPTAIN: 1,
      TEAM_ROLE_MAIN: 2,
      TEAM_ROLE_SUBS: 3,
      // hub announcement
      ANNOUNCEMENT_CREATE_TOUR: 'create-tournament',
      ANNOUNCEMENT_USER_REGISTERED: 'user-registered',
      ANNOUNCEMENT_TOUR_FINISHED: 'finished-tournament',
      ANNOUNCEMENT_MEMBER_JOIN: 'member-joined',
      ANNOUNCEMENT_SET_MOD: 'set-member-mod',
      ANNOUNCEMENT_SET_HUB_OWNER: 'set-hub-owner',
      ANNOUNCEMENT_SET_ADMIN: 'set-admin',
      ANNOUNCEMENT_MEMBER_LIVE: 'member-live',
      ANNOUNCEMENT_LOADMORE: 10,
      MEMBER_LOADMORE: 5,
      // hub who can join
      WHO_JOIN_ANYONE: 0,
      WHO_JOIN_INVITE_ONLY: 1,
      WHO_JOIN_APPROVAL: 2,
      // hub who can join team
      WHO_JOIN_TEAM_ANYONE: 0,
      WHO_JOIN_TEAM_INVITE_ONLY: 1,
      WHO_JOIN_TEAM_APPROVAL: 2,
      // hub who can create event
      WHO_CREATE_ANYONE: 0,
      WHO_CREATE_LEADERS_ONLY: 1,
      WHO_CREATE_APPROVAL: 2,
      // type of modal add member
      MODAL_ADD_OWNER: 1,
      MODAL_ADD_ADMIN: 2,
      // series branch
      SERIES_BRAND_NORMAL: 0,
      SERIES_BRAND_WEEKLY: 1,
      // team status
      TEAM_STATUS_PENDING: 0,
      TEAM_STATUS_APPROVED: 1,
      TEAM_STATUS_CREATED: 2,
      // new challenges tab
      TAB_GIVEAWAY: 1,
      TAB_LEADER_BOARD: 2,
      TAB_CHALLENGES: 3,
      // new drop status
      STATUS_END: 1,
      STATUS_LIVE: 2,
      STATUS_UPCOMING: 0,
      // region
      REGION_NAMES: {
        'all': 'All Regions',
        'NorthEast': 'North-East USA',
        'NorthWest': 'North-West USA',
        'MidWest': 'Mid-West USA',
        'South': 'South USA',
        'West': 'West USA',
        'WesternCanada': 'Western Canada',
        'EasternCanada': 'Eastern Canada',
        'NorthernCanada': 'Northern Canada',
      },
      timezone: '',
      multiSelectConfig: {},
      is_pending_member: false,
      user_choose_term: false,
      term_conditions: '',
      term_conditions_data: {},
      term_condition_step: 1,
    };
  },
  computed: {
    ...mapGetters('app', ['appConfig']),
    ...mapGetters('user', ['userData']),
    ...mapGetters('hub', ['hubData', 'hubUserData', 'currentTab', 'hubModal', 'showModalConnectGameAccount', 'newVersionHubData']),
    isMember() {
      return this.hubUserData.check_user_leader || this.hubUserData.check_user_member || this.hubUserData.check_user_admin;
    },
    checkUserJoinHub() {
      if (parseInt(this.hubData.hub_data.who_join) === this.WHO_JOIN_INVITE_ONLY && this.hubUserData.check_user_leader === 1) { // anyone can join hub
        return 1;
      } else if (parseInt(this.hubData.hub_data.who_join) === this.WHO_JOIN_ANYONE) {
        return 1;
      } else if (parseInt(this.hubData.hub_data.who_join) === this.WHO_JOIN_APPROVAL) {
        return 2;
      } else {
        return 0;
      }
    },
    checkUserCreateTournament() {
      if (parseInt(this.hubData.hub_data.hub_brand) === this.HUB_BRAND_NORMAL) {
        if (parseInt(this.hubData.hub_data.who_create_tournament) === this.WHO_CREATE_LEADERS_ONLY && parseInt(this.hubUserData.check_user_leader)) {
          return 1;
        } else if (parseInt(this.hubData.hub_data.who_create_tournament) === this.WHO_CREATE_APPROVAL) {
          return 1;
        } else if (parseInt(this.hubData.hub_data.who_create_tournament) === this.WHO_CREATE_ANYONE) {
          return 1;
        }
      }
      return 0;
    },
    countAllMember() {
      var formatter = new Intl.NumberFormat('en-US', {});
      return formatter.format(this.hubData.count_all_member);
    },
    countIntelInspiresParticipant2022() {
      return '2022 - 2023: ' + this.hubData.count_intel_inspires_participants + ' Active Participants';
    },
    gameOptions() {
      const gameOptions = [];
      for (const game in this.hubData['list_game_management']) {
        gameOptions.push({
          value: game,
          title: this.hubData['list_game_management'][game]['display_name'],
          img: this.hubData['list_game_management'][game]['game_icon_link'],
        });
      }
      return gameOptions;
    },
    hubDropsTheme() {
      if (parseInt(this.hubData.hub_data.override_theme_optimization) === 1) {
        return this.hubData.hub_data.hub_drops_theme.includes('#') ? this.hubData.hub_data.hub_drops_theme : '#' + this.hubData.hub_data.hub_drops_theme;
      }
      var hubDropsThemeHsl = this.covertColorFromHexToHsl(this.hubData.hub_data.hub_drops_theme);
      var l = hubDropsThemeHsl[2];
      if (l >= 80) {
        if (this.checkIsLightTheme()) {
          l = 100 - l;
        }
      } else {
        if (!this.checkIsLightTheme()) {
          l = 100 - l;
        }
      }
      return this.convertColorFromHslToHex(hubDropsThemeHsl[0], hubDropsThemeHsl[1], l);
    },
    isVerizonHub() {
      return this.hubData.hub_data.is_verizon_hub;
    },
  },
  created() {
    this.timezone = this.guessTimezone();
    this.multiSelectConfig = {
      optionHeight: 60,
      selectedLabel: '',
      selectLabel: '',
      deselectLabel: '',
      allowEmpty: false,
      preselectFirst: true,
      trackBy: 'value',
      searchable: false,
    };
    this.$root.$refs.HubMixin = this;
  },
  methods: {
    ...mapActions({
      setHubModal: 'hub/setHubModal',
      setShowModalConnectGameAccount: 'hub/setShowModalConnectGameAccount',
    }),
    checkMemberIsManagerOrCaptainOfTeam(teamData) {
      return parseInt(teamData.requester_id) === parseInt(teamData.manager_user) || parseInt(teamData.requester_id) === parseInt(teamData.captain);
    },
    checkUserHasPermission(permissions) {
      var listPermissions = permissions.split(',');
      for (var i = 0; i < listPermissions.length; i++) {
        if (this.hubUserData['list_permission_user'].includes(listPermissions[i])) {
          return true;
        }
      }
      return false;
    },
    checkUserHasSettingPermission() {
      return this.checkUserHasPermission('edit_hub_gears,edit_hub_logo,edit_hub_banner,connect_hub_discord,' +
        +'swap_who_can_join,swap_who_create_event,edit_twitter_social_links,edit_discord_link,edit_youtube_link,edit_twitch_link,swap_approval_teams_mode');
    },
    checkTabIsHubManagement() {
      return this.currentTab === 'settings' || this.currentTab === 'teams' || this.currentTab === 'requests';
    },
    checkTabIsFull() {
      return this.currentTab !== 'settings' && !this.currentTab !== 'teams' && this.currentTab === 'requests';
    },
    checkTabIsScrimmages() {
      return this.currentTab === 'find_scrimmage' || this.currentTab === 'create_scrimmage' || this.currentTab === 'manage_scrimmage';
    },
    showCommunityRight() {
      return this.currentTab !== 'lobby' && !this.checkTabIsHubManagement() && !this.checkTabIsScrimmages();
    },
    getCookie(name) {
      function escape(s) {
        return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1');
      }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
    },
    showModalGameAccountConnection() {
      this.setShowModalConnectGameAccount(true);
      EventBus.$emit(GAME_ACCOUNT_CONNECTION_TOGGLE_MODAL, true);
    },
    showModalHubPointsFaq() {
      document.documentElement.style['overflow-y'] = 'hidden';
      this.setHubModal({ modal: 'modal-faq-leaderboard' });
    },
    showLoadingIcon(el){
      var loadingImg = '<img src="' + this.appConfig.content_cloud_front + '/assets/v1/ellipsis.svg' + '" class="loading_img" style="display: block; margin: 0 auto">';
      el.addClass('loading').prepend(loadingImg);
    },
    hideLoadingIcon(el){
      el.removeClass('loading');
      el.find('.loading_img').remove();
    },
    convertLeagueRankToText(leagueRank) {
      var text;
      switch (leagueRank) {
        case 0:
          text = 'Bronze';
          break;
        case 1:
          text = 'Silver';
          break;
        case 2:
          text = 'Gold';
          break;
        case 3:
          text = 'Platinum';
          break;
        case 4:
          text = 'Diamond';
          break;
        case 5:
          text = 'Masters';
          break;
        case 100:
          text = 'Overall';
          break;
        default:
          text = 'Overall';
          break;
      }
      return text;
    },
    getTextWhoCanJoin(type) {
      var text;
      var typeIndex = parseInt(type);
      switch (typeIndex) {
        case this.WHO_JOIN_ANYONE:
          text = 'Open To All - Anyone can join your hub!';
          break;
        case this.WHO_JOIN_APPROVAL:
          text = 'By Approval - Admins must approve members';
          break;
        case this.WHO_JOIN_INVITE_ONLY:
          text = 'Invite Only - Invite members by email or link';
          break;
        default:
          text = 'Open To All - Anyone can join your hub!';
          break;
      }
      return text;
    },
    getTextWhoCanCreate(type) {
      var text;
      var typeIndex = parseInt(type);
      switch (typeIndex) {
        case this.WHO_CREATE_ANYONE:
          text = 'Open To All - Anyone in the hub can create events';
          break;
        case this.WHO_CREATE_APPROVAL:
          text = 'By Approval - Admins must approve events for the hub';
          break;
        case this.WHO_CREATE_LEADERS_ONLY:
          text = 'Leader Only - Only Admins can create events';
          break;
        default:
          text = 'Open To All - Anyone in the hub can create events';
          break;
      }
      return text;
    },
    getTextTeamApprove(type) {
      var text;
      var typeIndex = parseInt(type);
      switch (typeIndex) {
        case this.WHO_JOIN_TEAM_ANYONE:
          text = 'Open To Players - Any player can join teams freely';
          break;
        case this.WHO_JOIN_TEAM_APPROVAL:
          text = 'By Approval - Team managers or captains must approve players before they can join a team';
          break;
        case this.WHO_JOIN_TEAM_INVITE_ONLY:
          text = 'Invite Only - Players may only join teams through email invites from their team manager or captain';
          break;
        default:
          text = 'Open To Players - Any player can join teams freely';
          break;
      }
      return text;
    },
    getLinkEmail(email) {
      return 'mailto:' + email;
    },
    setHubDropdownValue(event) {
      event.target.parentNode.parentNode.children[1].children[0].innerHTML = event.target.innerText;
      event.target.parentNode.parentNode.children[0].value = event.target.innerText;
    },
    toggleCommunityDropdownHeaderMobile(event) {
      event.preventDefault();
      $(event.target).find('.com_dropdown').toggleClass('show');
    },
    clickHandle(event) {
      var communityDropdown = document.getElementsByClassName('community_dropdown');
      var comHamb = document.getElementsByClassName('com_hamburger')[0];
      var comDots = document.getElementsByClassName('com_dots')[0];
      if (event.target.className.includes('community_dropdown_main') && event.target.parentNode !== undefined && !event.target.parentNode.className.includes(' show')) {
        for (var i = 0; i < communityDropdown.length; i++) {
          communityDropdown[i].className = communityDropdown[i].className.replace(/ show/g, '');
        }
        event.target.parentNode.className += ' show';
        if (comHamb) {
          comHamb.className = comHamb.className.replace(/ show/g, '');
        }
        if (comDots) {
          comDots.className = comDots.className.replace(/ show/g, '');
        }
      } else if (event.target.className === 'com_hamburger') {
        for (var j = 0; j < communityDropdown.length; j++) {
          communityDropdown[j].className = communityDropdown[j].className.replace(/ show/g, '');
        }
        event.target.className += ' show';
        if (comDots) {
          comDots.className = comDots.className.replace(/ show/g, '');
        }
      } else if (event.target.className.includes('com_dots')) {
        for (var k = 0; k < communityDropdown.length; k++) {
          communityDropdown[k].className = communityDropdown[k].className.replace(/ show/g, '');
        }
        if (event.target.className === 'com_dots') {
          event.target.className += ' show';
        }
        if (comHamb) {
          comHamb.className = comHamb.className.replace(/ show/g, '');
        }
      } else {
        for (var l = 0; l < communityDropdown.length; l++) {
          communityDropdown[l].className = communityDropdown[l].className.replace(/ show/g, '');
        }
        if (comHamb) {
          comHamb.className = comHamb.className.replace(/ show/g, '');
        }
        if (comDots) {
          comDots.className = comDots.className.replace(/ show/g, '');
        }
      }
    },
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    showModalAddAdmin(type = this.MODAL_ADD_ADMIN) {
      var data = {
        type: type,
      };
      this.setHubModal({ modal: 'modal-add-admin', data: data });
    },
    async joinHub(hubInviteCode = '') {
      // for hub enable drops, go to how to when if user has already been a hub member
      if (parseInt(this.hubData.hub_data.allow_hub_drops) === 1 && this.isMember) {
        var elmnt = document.getElementById('quest_reward_hub');
        elmnt.scrollIntoView({
          behavior: 'smooth',
        });
        return;
      }

      if (!parseInt(this.userData.id)) {
        if (this.appConfig.isAvglDomain) {
          EventBus.$emit(SHOW_MODAL_ONBOARDING_INITIAL);
        } else {
          this.showModalLogin();
        }
        sessionStorage.setItem('action_before_register', 'join_hub');
        return;
      }

      if (parseInt(this.hubData.hub_data.is_college) === 1) {
        this.showModalCollegeEmailVerification();
      } else {
        if (this.checkShowTermAndCondition()) {
          this.getAndShowTermAndCondition();
          return;
        }
        this.$http.post('/hub/join-hub', {
          user_id: this.userData.id,
          hub_id: this.hubData.hub_data.id,
          hub_invite_code: hubInviteCode,
        }, {
          headers: {
            'X-CSRF-TOKEN': this.appConfig.csrfToken,
          },
        })
          .then(response => {
            if (response.data.status === 0) {
              if (parseInt(this.hubData.hub_data.allow_hub_drops) === 1) {
                // clear blur in hub drop leaderboard
                $('#community_my_drop_leaderboard_position').find('.community_my_drop_leaderboard_position_btn').addClass('hide');
                $('#community_my_drop_leaderboard_position').find('.community_drop_leaderboard_item').removeAttr('style');
              } else {
                this.showModalWelcomeJoinHub();
              }
              this.getHubMemberData();
              this.hubUserData.check_user_member = 1;
              sessionStorage.removeItem('action_before_register');
              if (parseInt(this.hubData.hub_data.is_new_version_hub) === 1) {
                if (this.isVerizonHub) {
                  this.gleamTrackingJoinVerizonHub(this.userData.email);
                } else {
                  this.gleamTrackingJoinHub(this.userData.email);
                }
              }
            } else if (response.data.status === 1) {
              this.showModalLogin();
            } else {
              const message = response.data.message ? response.data.message : response.data.msg;
              EventBus.$emit(SHOW_MODAL_BOOM_MESSAGE, message);
            }
          })
          .catch(error => {
            console.log('joinHub error request');
            console.log(error);
          });
      }
    },
    checkShowTermAndCondition() {
      if (parseInt(this.hubData.hub_data.allow_hub_drops) === 1 && this.term_condition_step <= parseInt(this.hubData.hub_data.count_term_conditions)) {
        return true;
      }
      // send facebook pixel tracking after accept last term and condition
      if (this.hubData.hub_data.alias === 'la-liga' && this.hubData.current_drop.length > 0) {
        this.leadTracking({ venuename: this.hubData.current_drop.current_city });
      }
      // attribution tracking after accepting last term and condition
      if (parseInt(this.hubData.hub_data.allow_hub_drops) === 1) {
        // GAME 9038: Attribution Tracking | Add Drop-Enabled Hub Events
        // eslint-disable-next-line no-undef
        window.saveEventAnalyticsData('DROP_HUB_REGISTRATION_COMPLETE', this.appConfig.csrfToken, { user_id: this.userData.id, hub_url: this.hubData.hub_data.hub_url });
      }
      return false;
    },
    getAndShowTermAndCondition(hubInviteCode = '') {
      this.$http.get('/hub/get-hub-term-and-condition', {
        params: {
          'hub_id': this.hubData.hub_data.id,
          'step': this.term_condition_step,
        },
      })
        .then(response => {
          if (response.data.status === 0) {
            this.term_conditions = response.data.term_conditions;
            this.term_conditions_data = response.data.get_term;
            if (parseInt(this.term_conditions_data.optional)) {
              this.user_choose_term = true;
            } else {
              this.user_choose_term = false;
            }
            this.showModalTermAndCondition(hubInviteCode);
            if (parseInt(this.hubData.hub_data.allow_hub_drops) && parseInt(this.term_condition_step) === 1) {
              // GAME 9038: Attribution Tracking | Add Drop-Enabled Hub Events
              // eslint-disable-next-line no-undef
              window.saveEventAnalyticsData('DROP_HUB_REGISTRATION_INIT', this.appConfig.csrfToken, { user_id: this.userData.id, hub_url: this.hubData.hub_data.hub_url });
            }
          }
        })
        .catch(error => {
          console.log(error);
          console.log('getAndShowTermAndCondition error request');
        });
    },
    showModalTermAndCondition(hubInviteCode = '') {
      var data = {
        'term_conditions_data': this.term_conditions_data,
        'term_conditions': this.term_conditions,
        'user_choose_term': this.user_choose_term,
        'hub_invite_code': hubInviteCode,
      };
      this.setHubModal({ modal: 'modal-term-and-condition-hub', data: data });
    },
    showHubPopupCreateTeam(team) {
      if (!team) {
        this.setHubModal({ modal: 'modal-create-team' });
        return;
      }
      console.log('showHubPopupCreateTeam');
      console.log(team);
      var data = {
        hub_teams: team,
      };
      this.setHubModal({ modal: 'modal-create-team', data: data });
    },
    showPopupAddHubMember(type) {
      var data = {
        'type': type,
      };
      this.setHubModal({ modal: 'modal-add-hub-member', data: data });
    },
    showModalInviteHub() {
      this.setHubModal({ modal: 'modal-invite-hub' });
    },
    showPopupEditMember(title, userDataEdit, type) {
      var data = {
        user_data_edit: userDataEdit,
        title_popup_edit: title,
        popup_edit_user_type: type,
      };

      this.setHubModal({ modal: 'modal-edit-member', data: data });
    },
    showPopupEditPlayer(userDataEdit, type, teamData) {
      var data = {
        user_data_edit: userDataEdit,
        popup_type: type,
        team_data: teamData,
      };

      this.setHubModal({ modal: 'modal-edit-player', data: data });
    },
    showModalCreateSeriesStep1() {
      this.setHubModal({ modal: 'modal-create-series-step1' });
    },
    showModalSubmitHubClip() {
      this.setHubModal({ modal: 'modal-submit-hub-clip' });
    },
    requestJoinHub() {
      if (this.hubData.hub_data.is_college === 1) {
        if (this.userData.id !== '0') {
          this.showModalCollegeEmailVerification();
        } else {
          this.showModalLogin();
        }
      } else {
        this.$http.post('/hub/request-join-hub', {
          user_id: this.userData.id,
          hub_id: this.hubData.hub_data.id,
        }, {
          headers: {
            'X-CSRF-TOKEN': this.appConfig.csrfToken,
          },
        })
          .then(response => {
            if (response.data.status === 0) {
              this.is_pending_member = true;
              this.showModalBoomMsg('Your request to be a member has been sent!');
              this.$set(this.hubUserData, 'check_user_pending_member', 1);
            } else if (response.data.status === 1) {
              this.showModalLogin();
            } else {
              this.showModalBoomMsg(response.data.msg);
            }
          })
          .catch(error => {
            console.log('requestJoinHub error request');
            console.log(error);
          });
      }
    },
    showMemberStatus(name) {
      var url = this.appConfig.baseUrl + '/profile/' + name;
      window.open(url, '_blank');
    },
    showModalCollegeEmailVerification() {
      this.setHubModal({ modal: 'modal-college-email-verification' });
    },
    showModalWelcomeJoinHub() {
      this.setHubModal({ modal: 'modal-welcome-join-hub' });
    },
    showModalReport() {
      this.setHubModal({ modal: 'modal-report-clip-event' });
    },
    showModalCreateChannelName() {
      this.setHubModal({ modal: 'modal-create-hub-discord-channel' });
    },
    showPopupCreateHubTeam() {
      this.setHubModal({ modal: 'modal-create-team' });
    },
    setCookieHubDiscord() {
      console.log('setCookieHubDiscord');
      var token = this.getCookie('discord_token_' + this.appConfig.cookieSurffix);
      var cssTitan = this.appConfig.isAvglDomain ? this.appConfig.css_titan_avgl : this.appConfig.css_titan;
      if (this.userData && this.userData.theme && this.userData.theme === 'light') {
        cssTitan = this.appConfig.css_titan_light_theme;
      }
      if (this.hubData.hub_data.discord_default_room) {
        this.link_hub_discord = 'https://' + this.appConfig.urlTitanEmbed + '/embed/' + this.hubData.hub_data.discord_id + '?css=' + cssTitan + '&defaultchannel=' + this.hubData.hub_data.discord_default_room + '&lang=en_US&c=' + token;
      } else {
        this.link_hub_discord = 'https://' + this.appConfig.urlTitanEmbed + '/embed/' + this.hubData.hub_data.discord_id + '?css=' + cssTitan + '&lang=en_US&c=' + token;
      }
      if (!this.hubData.hub_data.discord_id) {
        this.link_hub_discord = 'https://' + this.appConfig.urlTitanEmbed + '/embed/' + this.hubData.hub_data.discord_id + '?css=' + cssTitan + '&lang=en_US&c=' + token;
      }
    },
    getLinkInviteHub() {
      if (parseInt(this.hubData.hub_data.who_join) === parseInt(this.WHO_JOIN_INVITE_ONLY)) {
        return this.hubData.hub_data.hub_url + '/join/' + this.hubData.hub_data.invitation_code;
      }
      return this.hubData.hub_data.hub_url + '/join';
    },
    copyLinkJoinHub(el_btn) {
      const linkInviteHub = this.getLinkInviteHub();
      this.copyLinkJoinHubToClipboard(linkInviteHub);

      this.copying = true;
      var self = this;
      setTimeout(function(){
        self.copying = false;
      }, 1000);
    },
    copyLinkJoinHubToClipboard(text) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
      } catch (err) {
        console.log('Oops, unable to copy');
        console.log(err);
      }
      document.body.removeChild(textArea);
    },
  },
};
